<div class="d-flex justify-content-between mb-30">
    <h4>{{ "widget_product_catalog_title" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="row mb-30">
    <div class="col-xs-4">
        <div class="input-group">
            <span class="input-group-addon"><span class="sp-icon icon-list" aria-hidden="true"></span></span>
            <select class="form-control" (change)="setCategory(+$event.target['value'])">
                <option [value]="null" [selected]="(selectedCategory$ | async) === null">
                    {{ "widget_product_catalog_category_all" | translate }}
                </option>
                @for (category of flattenedCategories$ | async; track category) {
                    <option [value]="category.id" [selected]="category.id === (selectedCategory$ | async)">
                        {{ category.name }}
                    </option>
                }
            </select>
        </div>
    </div>
    <div class="col-xs-2"></div>
    <div class="col-xs-6">
        <div class="input-group">
            <span class="input-group-addon"><span class="sp-icon icon-ap-search" aria-hidden="true"></span></span>
            <input
                type="text"
                class="form-control"
                [placeholder]="'widget_product_catalog_search_placeholder' | translate"
                [formControl]="searchControl"
            />
        </div>
    </div>
</div>
<div class="d-flex flex-wrap catalog-block">
    @if ((loading$ | async) === false) {
        @if ((cards$ | async)?.length) {
            @for (element of cards$ | async; track element) {
                @if (element.visible) {
                    <web-catalog-card
                        [element]="element"
                        (setProductCardEvenEmitter)="onConfirm($event)"
                    ></web-catalog-card>
                }
            }
        } @else {
            <div class="empty-state text-center w-100">
                <div class="help-block">
                    {{ "widget_product_catalog_empty_state" | translate }}
                </div>
                <button class="btn btn-action btn-sm" (click)="setCategory(null)">
                    {{ "widget_product_catalog_cleat_button" | translate }}
                </button>
            </div>
        }
    } @else {
        <div class="loader">
            <div class="preloader preloader-puff-rounds"></div>
        </div>
    }
</div>

@if ((total$ | async) > PER_PAGE_ELEMENTS) {
    <nav>
        <ul class="pager">
            <li [class.disabled]="+offsetControl.value === 0">
                <a (click)="paginationHandler()">{{ "pagination_previous" | translate }}</a>
            </li>
            <li [class.disabled]="+offsetControl.value + PER_PAGE_ELEMENTS >= (total$ | async)">
                <a (click)="paginationHandler(true)">{{ "pagination_next" | translate }}</a>
            </li>
        </ul>
    </nav>
}
